import { Pipe, PipeTransform } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ClientWithDesignAdminCSS } from '@shared/constants/site-config-client-exceptions';
import { ClientPath } from '@shared/models/client-path.enum';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import * as fromGlobalStore from '@shared/store';
import { CustomAssetsState } from '@shared/store/customizable-assets/reducers/custom-assets.reducers';
import { CustomAssetImage } from '../shared/interfaces/custom-assets.interfaces';

@Pipe({ name: 'customImage', standalone: true })
export class CustomImagePipe implements PipeTransform {
  constructor(
    private ngrxStore: Store<CustomAssetsState>,
    private siteSettingsService: SiteSettingsService
  ) {}

  public transform(customAsset: string): Observable<CustomAssetImage> {
    const isClientWithDesignAdminCSS = ClientWithDesignAdminCSS.includes(
      this.siteSettingsService.settings.fe_configuration.path as ClientPath
    );
    if (isClientWithDesignAdminCSS) {
      return of(null);
    }
    return this.ngrxStore.select(fromGlobalStore.getSpecificCustomAsset, { customAsset }).pipe(
      filter((images) => !!images?.length),
      map((images) => images[0])
    );
  }
}
